import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SHARE_BET_HOST: InjectionToken<string> = new InjectionToken<string>('shareBetHost');
